<template>
  <table-paginator :data="purchases" @pagechange="$emit('pagechange', $event)">
    <div class="row grid-table-heading">
      <div
        class="col-1 order-1 col-md-1 order-md-1 align-rigth text-md-center text-primary"
      >
        Número
      </div>
      <div
        class="col-1 order-2 col-md-1 order-md-2 align-rigth text-md-center text-primary"
      >
        Série/Mod
      </div>

      <div
        class="col-3 order-3 col-md-2 order-md-3 align-rigth text-md-center text-primary"
      >
        Fornecedor
      </div>
      <div
        class="col-1 order-4 col-md-1 order-md-4 align-middle text-center text-primary"
      >
      Cadastro   
      </div>
       <div
        class="col-1 order-5 col-md-1 order-md-5 align-middle text-center text-primary"
      > Emissão NF      
      </div>

       <div
        class="col-1 order-6 col-md-1 order-md-6 align-middle text-center text-primary"
      >
        Entrada
      </div>
      <div
        class="col-1 order-7 col-md-1 order-md-7 align-rigth text-md-center text-primary"
      >
        Valor Produtos
      </div>
      <div
        class="col-1 order-8 col-md-1 order-md-8 align-rigth text-md-center text-primary  px-0"
      >
        Valor NF-e
      </div>
      <div
        class="col-1 order-9 col-md-1 order-md-9 align-middle text-md-center text-right"
      >
        Financeiro/Estoque
      </div>
      <div
        class="col-1 order-10 col-md-1 order-md-10 align-middle text-md-end pr-0 text-right"
      >
        Status
      </div>
    </div>
    <hr />

    <template v-for="row in purchases.data">
      <div class="row grid-table-row" :key="row.id" @click="redirect(row.id)">
        <div
          class="col-1 order-1 col-md-1 order-md-1 align-rigth text-md-center text-muted"
        >
          {{ row.number }}#
        </div>
        <div
          class="col-1 order-2 col-md-1 order-md-2 align-rigth text-md-center text-primary"
        >
          {{ row.serie }}/
          {{ row.mod }}
        </div>

        <div
          class="col-2 order-3 col-md-2 order-md-3 align-rigth text-md-center text-primary"
        >
          <!-- <avatar
                  inline
                  color="#fff"
                  :size="30"
                  :username="row.name"
                  :initials="row.name.slice(0, 1)"
                ></avatar> -->
          <span style="margin-left: 10px">{{ row.name }}</span>
        </div>
        <div class="col-1 order-4 col-md-1 order-md-4 align-middle text-center"
        >  {{row.saved_at | dateBr}}
        </div>
         <div
          class="col-1 order-5 col-md-1 order-md-5 align-middle text-md-center text-right"
        >
         {{row.emited_at | dateBr }}
        </div>
        <div
          class="col-1 order-6 col-md-1 order-md-6 align-middle text-md-center text-right"
        >
         {{row.entry_at | dateBr}}
        </div>
        
        <div
          class="col-1 order-7 col-md-1 order-md-7 align-rigth text-md-center text-primary"
        >
          <b>{{ row.product_total | decimal }}</b>
        </div>
        
        <div
          class="col-1 order-8 col-md-1 order-md-8 align-rigth text-md-center text-primary"
        >
          <b>{{ row.net_total | decimal }}</b>
        </div>

        <div
          class="col-1 order-9 col-md-1 order-md-9 align-middle text-md-center text-right"
        >
          <i
            class="fas fa-dollar-sign text-success"
            style="margin-rigth: 5px"
          ></i>
          <i
            class="fas fa-sm fa-check text-primary"
            style="margin-rigth: 5px"
            v-if="row.finance_status == 1"
          ></i>
          <i
            class="fas fa-sm fa-times text-danger"
            style="margin-rigth: 5px"
            v-if="row.finance_status == 0"
          ></i
          >&nbsp;&nbsp;

          <i class="fas fa-cubes text-success" style="margin-rigth: 5px"></i>
          <i
            class="fas fa-sm fa-check text-primary"
            style="margin-rigth: 5px"
            v-if="row.stock_status == 1"
          ></i>
          <i
            class="fas fa-sm fa-times text-danger"
            style="margin-rigth: 5px"
            v-if="row.stock_status == 0"
          ></i
          >&nbsp;&nbsp;
        </div>
        <div
          class="col-1 order-10 col-md-1 order-md-10 align-middle text-md-end pr-0 text-right"
        >
          <purchase-status-badge :purchase="row" />
        </div>
       

        <div class="col-12 order-11 col-md-1 order-md-11 align-end text-rigth">
          <b-dropdown
            variant="light"
            dropleft
            :boundary="'window'"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v text-muted" />
            </template>
            <template v-if="row.finance_status !== 1 && purchaseCreateEdit">
              <b-dropdown-item @click.stop="$emit('emitPurchaseBill', row)">
                <b-dropdown-divider></b-dropdown-divider>
                <i class="fas fa-cash-register" />
                Lançar Contas
              </b-dropdown-item>
            </template>
            <template v-if="row.stock_status !== 1 && purchaseCreateEdit">
              <b-dropdown-item @click.stop="$emit('emitStockTransaction', row)">
                <b-dropdown-divider></b-dropdown-divider>
                <i class="fas fa-box" />
                Lançar Estoque
              </b-dropdown-item>
            </template>
            <template v-if="row.status !== 'c' && purchaseCancel">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click.stop="$emit('cancelPurchase', row)">
                <i class="fas fa-ban text-danger" />
                Cancelar
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>

      </div>
    </template>
  </table-paginator>
</template>

<script>
import TablePaginator from "../../sections/TablePaginator";
import Avatar from "vue-avatar";
import PurchaseStatusBadge from "@/components/purchase/sections/PurchaseStatusBadge";

export default {
  components: {
    TablePaginator,
    Avatar,
    PurchaseStatusBadge,
  },

  props: {
    purchases: {},
  },

computed: {
  purchaseCancel () {
		return this.$acl.can('purchaseCancel')
  },
  purchaseCreateEdit () {
		return this.$acl.can('purchaseCreateEdit')
  },
},

methods : {
    redirect(id) {
      this.$router.push("/compras/editar/" + id);
    },
  }
};
</script>

<style>
</style>